import { RecommendationSkeleton } from "@/features/dashboard/components/skeletons/RecommendationSkeleton";
import { LearningProgressCard } from "@/features/dashboard/components/learning-progress/LearningProgressCard";
import { WeeklyStudyTimeCard } from "@/features/study-time/components/WeeklyStudyTimeCard";
import { SuggestedTaskCard } from "@/features/study/components/SuggestedTaskCard";
import { TRecommendation, useDashboardStudy } from "@/infrastructure/adapters/study";
import { useCurriculumProgress } from "@/api/services/main/curriculum-progress";
import { useTrialStatus } from "@/hooks/useTrialStatus";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";
import { FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";

export const DashboardContent: FC = () => {
  const navigate = useNavigate();
  const { progress, isLoading: isLoadingCurriculum } = useCurriculumProgress();
  const { recommendation, isLoading: isLoadingRecommendation } = useDashboardStudy({ enabled: (progress?.subjects?.length ?? 0) > 0 });
  const { isTrial } = useTrialStatus();

  /** Navigate to settings by adding query param */
  const handleSettingsClick = useCallback(() => {
    navigate(AppRoutes.more);
  }, [navigate]);

  const recommendedSubjectId = recommendation?.type === "MOCK_EXAM" ? undefined : recommendation?.publishedSubjectId;
  return (
    <Stack gap={2.5}>
      <WeeklyStudyTimeCard onSettingsClick={handleSettingsClick} />
      <RecommendationCard isLoading={isLoadingRecommendation} recommendation={recommendation} />
      <LearningProgressCard
        progress={progress}
        recommendedSubjectId={recommendedSubjectId}
        isLoading={isLoadingCurriculum || isLoadingRecommendation}
        isTrial={isTrial}
      />
    </Stack>
  );
};

const RecommendationCard = ({ isLoading, recommendation }: { isLoading: boolean; recommendation: TRecommendation | null }) => {
  if (isLoading) {
    return <RecommendationSkeleton />;
  }

  return <SuggestedTaskCard recommendation={recommendation} />;
};
